export default "__VITE_ASSET__B8v3uZ6f__"